import { object } from "prop-types";
import { observer } from "mobx-react";
import { PriceFormats, SummaryColumns } from "@repo/utils";
import { useEstimateStructure, useVisibilityModeCellClassName, ValueCell } from "@tools";

export const PriceModifierCostCell = observer(({
  priceModifier,
  ...cellProps
}) => {
  const structure = useEstimateStructure();
  const {
    hide,
    displayPrice,
    displayPriceMax,
    showMaxPrice,
  } = priceModifier;
  const { currencyObj, roundPrice, priceFormat } = structure.settings;
  const className = useVisibilityModeCellClassName(hide);
  
  return (
    <ValueCell
      colName={ SummaryColumns.COST }
      useDynamicWidth
      displayContent
      useInputBackground
      usePriceFormat
      applySuffixSpacing
      value={displayPrice}
      valueMax={displayPriceMax}
      displayMax={showMaxPrice}
      showDecimals={!roundPrice}
      symbolStart={currencyObj.symbolStart}
      symbolEnd={currencyObj.symbolEnd}
      americanFormat={priceFormat === PriceFormats.AMERICAN}
      allowNegative
      className={className}
      textPresetClass="preset-price"
      {...cellProps}
    />
  );
});

PriceModifierCostCell.propTypes = {
  priceModifier: object.isRequired,
}